import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface UserSlice {
  username: string;
  smartID: string;
}

const initialState: UserSlice = {
  username: '',
  smartID: '',
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(_, action: PayloadAction<UserSlice>) {
      return action.payload;
    },
    clearUser() {
      return initialState;
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;

export default userSlice.reducer;
